import { User } from "../models/User";
import { Person } from "../../persons/entities/Person";

import { Token } from "./Token";

export class Auth {

    /** 
     * @returns {User}
    */
    static user() {
        return new User(JSON.parse(localStorage.getItem('user')) || {});
    }

    static person() {
        try {
            return new Person(JSON.parse(localStorage.getItem('person') || '{}'));
        } catch (error) {
            return new Person({});
        }
    }

    static logout() {
        Token.clear();
        localStorage.removeItem('user');
    }
}